






















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
import cloneDeep from 'lodash/cloneDeep';

import DensitiesManagerForm from './DensitiesManagerForm/DensitiesManagerForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar
  }
})
export default class DensitiesManager extends Vue {
  radioButton = 1;

  get titleStack () {
    return [
      'Настройки', 'Словари', 'Густота во время варке'
    ]
  }

  get queryParams() {
    return cloneDeep(this.$route.query);
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  setFilter(filterName: string, filterValue: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue
      }
    })
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  private delayFilter: any = null
  private delayFilterValue: any = null

  onSearch(filter: string, value: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
      query: {
        ...this.$route.query, [this.delayFilter]: this.delayFilterValue
      }
    })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
    this.delayFilterValue = value
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: DensitiesManagerForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
    // this.$buefy.dialog.prompt({
    //   message: `Роль в смене`,
    //   inputAttrs: {
    //     placeholder: 'Наименование',
    //     value: row.name,
    //   },
    //   confirmText: 'Сохранить',
    //   cancelText: 'Отмена',
    //   trapFocus: true,
    //   onConfirm: (value: any) => {
    //     this.$store.dispatch(`${STORE_KEY}/saveTodoType`, {
    //       id: row.id,
    //       name: value
    //     })
    //     .then((result) => {
    //       this.$buefy.snackbar.open(`Запись успешно сохранена`);
    //       this.handleParamsChange();
    //     })
    //     .catch(() => {
    //       this.$buefy.snackbar.open({
    //         type: 'is-warning',
    //         message: `При сохранении возникли проблемы. Попробуйте позже.`
    //       })
    //     })
    //   }
    // })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }

}
